import {UmpireImage} from '../umpire-image';

export interface UmpireSponsor {
  type: 'sponsor';

  id: string;

  name: string | null;

  image: Partial<UmpireImage>;

  external_url: string | null;

  relationshipNames: string[];

  created_at: string | null;
}
